// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RightPanelHeader__header-container-c53d26 {
  display: flex;
  padding: 0 16px;
  align-items: center;
  height: 72px;
}

.RightPanelHeader__content-d1bcc0 {
  flex: 1 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.RightPanelHeader__title-f80c09 {
  font: var(--font-body-1);
  letter-spacing: var(--font-spacing-body-1);
  color: var(--addition-50);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/FullScreenCallView/Shared/AnimatedRightPanel/RightPanel/RightPanelHeader/RightPanelHeader.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,yBAAA;AACF","sourcesContent":[".header-container {\n  display: flex;\n  padding: 0 16px;\n  align-items: center;\n  height: 72px;\n}\n\n.content {\n  flex: 1 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.title {\n  font: var(--font-body-1);\n  letter-spacing: var(--font-spacing-body-1);\n  color: var(--addition-50);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header-container": `RightPanelHeader__header-container-c53d26`,
	"headerContainer": `RightPanelHeader__header-container-c53d26`,
	"content": `RightPanelHeader__content-d1bcc0`,
	"title": `RightPanelHeader__title-f80c09`
};
module.exports = ___CSS_LOADER_EXPORT___;
